import React, { FC } from 'react'

import { styled } from '@linaria/react'
import { Link } from 'react-router-dom'

import { VoidHandler, WithClassName } from 'common/types'
import { Meatballs } from 'components/designSystem/Meatballs/Meatballs'
import { zIndex } from 'components/designSystem/zIndex'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useAuthorized } from 'hooks/useAuthorized'
import { useIsMobileView } from 'hooks/useIsMobileView'

import { Desktop } from './block/Desktop/Desktop'
import { Mobile } from './block/Mobile/Mobile'

/**
 * На desktop popover
 * На mobile bottomSheet
 */
export const ShareComplaintMenu: FC<
  WithClassName & { profileId: number; onCallback?: VoidHandler }
> = ({ className, profileId, onCallback }) => {
  const authorized = useAuthorized()
  const authorizationPath = useAuthorizationPath()
  const isMobile = useIsMobileView()

  if (!authorized) {
    return (
      <Link
        to={authorizationPath}
        className={className}
        data-name="sharing-complains-not-auth-action"
      >
        <Meatballs />
      </Link>
    )
  }

  return (
    <>
      {!isMobile && (
        <Desktop
          profileId={profileId}
          className={className}
          onCallback={onCallback}
        />
      )}
      {isMobile && (
        <Mobile
          profileId={profileId}
          className={className}
          onCallback={onCallback}
        />
      )}
    </>
  )
}

export const ShareComplaintProfile = styled(ShareComplaintMenu)`
  position: absolute;
  top: var(--spacing-18px);
  z-index: ${zIndex.default};

  html[dir='ltr'] & {
    right: var(--spacing-24px);
  }

  html[dir='rtl'] & {
    left: var(--spacing-24px);
  }
`
